import { Base } from "../../../../../base/components/base"
import services from "../../../../../services"
import { toJalaaliShortString, toJalaaliString } from "./jalaali-utils"

export const AnalyticsChart = () => {
    const base = Base('div')
    base.style({
        width: '100%',
        height: '100%',
        position: 'relative',
        direction: 'ltr' // Charts are usually LTR
    })

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    svg.setAttribute("width", "100%")
    svg.setAttribute("height", "100%")
    svg.style.overflow = "visible"
    base.el.appendChild(svg)

    let currentContentId: string | null = null
    let currentDays: number = 30

    async function load(contentId: string, title: string, days: number = 30) {
        currentContentId = contentId
        currentDays = days
        base.el.innerHTML = '' // Clear previous chart
        base.el.appendChild(svg)
        while (svg.lastChild) {
            svg.removeChild(svg.lastChild)
        }

        const loadingText = document.createElement("div")
        loadingText.innerText = "Loading chart..."
        loadingText.style.position = "absolute"
        loadingText.style.top = "50%"
        loadingText.style.left = "50%"
        loadingText.style.transform = "translate(-50%, -50%)"
        base.el.appendChild(loadingText)

        try {
            const data: { _id: string, views: number }[] = await services.api.request('/api/analytics/views-by-date/' + contentId + '?days=' + days)
            loadingText.remove()

            if (!data || data.length === 0) {
                const noData = document.createElement("div")
                noData.innerText = "No data available for " + title
                noData.style.textAlign = "center"
                noData.style.marginTop = "50px"
                base.el.appendChild(noData)
                return
            }

            renderChart(data, title)

        } catch (error) {
            console.error(error)
            loadingText.innerText = "Error loading chart"
        }
    }

    function renderChart(data: { _id: string, views: number }[], title: string) {
        const padding = 40
        const width = base.el.clientWidth
        const height = base.el.clientHeight
        const chartWidth = width - (padding * 2)
        const chartHeight = height - (padding * 2)

        const maxViews = Math.max(...data.map(d => d.views))
        const dates = data.map(d => d._id)

        // Title
        const titleText = document.createElementNS("http://www.w3.org/2000/svg", "text")
        titleText.setAttribute("x", (width / 2).toString())
        titleText.setAttribute("y", (padding / 2).toString())
        titleText.setAttribute("text-anchor", "middle")
        titleText.setAttribute("font-size", "16px")
        titleText.textContent = title
        svg.appendChild(titleText)

        // Y Axis Lines & Labels
        const ySteps = 5
        for (let i = 0; i <= ySteps; i++) {
            const yVal = Math.round((maxViews / ySteps) * i)
            const yPos = height - padding - ((yVal / maxViews) * chartHeight)

            const line = document.createElementNS("http://www.w3.org/2000/svg", "line")
            line.setAttribute("x1", padding.toString())
            line.setAttribute("y1", yPos.toString())
            line.setAttribute("x2", (width - padding).toString())
            line.setAttribute("y2", yPos.toString())
            line.setAttribute("stroke", "#eee")
            svg.appendChild(line)

            const label = document.createElementNS("http://www.w3.org/2000/svg", "text")
            label.setAttribute("x", (padding - 5).toString())
            label.setAttribute("y", (yPos + 5).toString())
            label.setAttribute("text-anchor", "end")
            label.setAttribute("font-size", "12px")
            label.textContent = yVal.toString()
            svg.appendChild(label)
        }

        // X Axis Labels (Jalaali dates)
        const xStep = Math.ceil(dates.length / 5)
        dates.forEach((date, index) => {
            if (index % xStep === 0 || index === dates.length - 1) {
                const xPos = padding + ((index / (dates.length - 1)) * chartWidth)
                const label = document.createElementNS("http://www.w3.org/2000/svg", "text")
                label.setAttribute("x", xPos.toString())
                label.setAttribute("y", (height - 5).toString())
                label.setAttribute("text-anchor", "middle")
                label.setAttribute("font-size", "10px")
                // Convert to Jalaali short format (MM/DD in Persian)
                label.textContent = toJalaaliShortString(date)
                svg.appendChild(label)
            }
        })

        // Points & Path
        let pathD = ""
        data.forEach((d, index) => {
            const xPos = padding + ((index / (dates.length - 1)) * chartWidth)
            const yPos = height - padding - ((d.views / maxViews) * chartHeight)

            if (index === 0) {
                pathD += `M ${xPos} ${yPos}`
            } else {
                pathD += ` L ${xPos} ${yPos}`
            }

            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle")
            circle.setAttribute("cx", xPos.toString())
            circle.setAttribute("cy", yPos.toString())
            circle.setAttribute("r", "3")
            circle.setAttribute("fill", "#007bff")

            // Tooltip on hover with Jalaali date
            const titleEl = document.createElementNS("http://www.w3.org/2000/svg", "title")
            const jalaaliDate = toJalaaliString(d._id, 'full')
            titleEl.textContent = `${jalaaliDate}: ${d.views} بازدید`
            circle.appendChild(titleEl)

            svg.appendChild(circle)
        })

        const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
        path.setAttribute("d", pathD)
        path.setAttribute("fill", "none")
        path.setAttribute("stroke", "#007bff")
        path.setAttribute("stroke-width", "2")
        svg.insertBefore(path, svg.children[0]) // Put path behind dots
    }

    return Object.assign(base, {
        load
    })
}
